/* jc-header — drawer toggle, sticky-shadow state, and header height vars.
 *
 * Plain script on purpose (no @theme/component dependency): the header must
 * work even if the theme's module graph changes. The cart count is the one
 * piece that reuses theme machinery (<cart-icon> + cart-bubble snippet).
 *
 * Sets --header-height / --header-group-height on <body> because theme CSS
 * and drawers read them; the stock inline script in theme.liquid no-ops when
 * it finds no <header-component>, so we own these vars now.
 */
(function () {
  var section = document.querySelector('.jc-header-section');
  var root = document.querySelector('.jc-header');
  if (!section || !root) return;

  var announce = root.querySelector('.jh-announce');
  var bar = root.querySelector('.jh-bar');
  var burger = root.querySelector('.jh-burger');
  var drawer = root.querySelector('.jh-drawer');
  var backdrop = root.querySelector('.jh-backdrop');
  var closeBtn = root.querySelector('.jh-d-close');

  /* ---- height bookkeeping ---- */
  function setHeights() {
    var announceH = announce ? announce.offsetHeight : 0;
    var barH = bar ? bar.offsetHeight : 0;
    section.style.setProperty('--jh-announce-h', announceH + 'px');
    document.body.style.setProperty('--header-height', barH + 'px');
    document.body.style.setProperty('--header-group-height', announceH + barH + 'px');
  }
  setHeights();
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(setHeights);
    if (announce) ro.observe(announce);
    if (bar) ro.observe(bar);
  } else {
    window.addEventListener('resize', setHeights);
  }

  /* ---- shadow once the bar is pinned ----
     Capture-phase document listener: on >=990px the theme scrolls
     .page-wrapper (html/body are overflow:hidden), and element scroll
     events don't bubble to window. getBoundingClientRect is viewport-
     relative, so "bar at 0" == pinned regardless of which element scrolls
     (at page top the bar sits below the 38px announcement strip). */
  var stuck = false;
  function onScroll() {
    var nowStuck = bar.getBoundingClientRect().top <= 0;
    if (nowStuck !== stuck) {
      stuck = nowStuck;
      section.classList.toggle('jh-stuck', stuck);
    }
  }
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  onScroll();

  /* ---- drawer ---- */
  if (!burger || !drawer) return;

  function setMenu(open) {
    root.classList.toggle('jh-open', open);
    document.body.classList.toggle('jh-lock', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      if (closeBtn) closeBtn.focus();
    } else {
      burger.focus();
    }
  }
  var isOpen = function () { return root.classList.contains('jh-open'); };

  burger.addEventListener('click', function () { setMenu(!isOpen()); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); });
  if (backdrop) backdrop.addEventListener('click', function () { setMenu(false); });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { setMenu(false); return; }
    /* minimal focus trap while the drawer is open */
    if (e.key === 'Tab') {
      var focusables = drawer.querySelectorAll('a[href], button:not([disabled])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
  });

  /* close the drawer when a link inside it is followed (anchor jumps on the
     same page would otherwise leave it open under the backdrop) */
  drawer.addEventListener('click', function (e) {
    if (e.target instanceof Element && e.target.closest('a[href]')) setMenu(false);
  });

  /* leaving mobile widths with the drawer open would strand the scroll lock */
  var mq = window.matchMedia('(min-width: 981px)');
  var onMq = function () { if (mq.matches && isOpen()) setMenu(false); };
  if (mq.addEventListener) mq.addEventListener('change', onMq);
  else mq.addListener(onMq);
})();
